import { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Link from '../../../Utilities/Link'
import ProgrammableLink from '../../../Utilities/ProgrammableLink'
import { Container, H2, H4, Subtitle1, Body1, Share, Button, EmailOptin, CheckSubscription } from '../../../cdl-react-components/components'
import EditButton from '../../../Utilities/EditButton'
import { DJANGO_URL } from '../../../cdl-react-components/utilities/constants'
import { formatFileLink } from '../../../cdl-react-components/utilities/files'
import { formatBytes } from '../../../cdl-react-components/utilities/files'
import { formatResultsItemDate } from '../../../../utilities'

class ActivityMapDesktop extends Component {
    renderDownloadButton = (activityMap, authenticated, user) => {
        if (!activityMap.pdf)
            return null
        else if (new Date(activityMap.publication_date) > new Date())
            return null
        else if (authenticated)
            return (
                <ProgrammableLink 
                    href={this.props.link}
                    target="_blank" rel="noreferrer"
                    onBeforeRedirect={this.props.logMapOpened}>
                    <Button raised style={{ width: '100%' }}>Download Map</Button>
                </ProgrammableLink>
            )
        else if (activityMap.sample_pdf)
            return <Link className="btn btn--raised activity-map__read-article-btn" href={this.props.sampleLink}>Download Map</Link>
        else if (user)
            return <Link className="btn btn--raised activity-map__read-article-btn" href="/subscribe">Subscribe to Download Map</Link>
        else
            return (
                // <div className="flex flex--end">
                //     <Link className="btn activity-map__read-article-btn" href="/subscribe">Subscribe</Link>
                    <Button className="activity-map__read-article-btn" raised onClick={this.props.handleLogin}>Login to View Map</Button>
                //</div>
            )
    }

    renderContents = activityMap => {
        return (
            <div className="activity-map__contents">
                <H4>Contents</H4>
                <table>
                    <tbody>
                        {activityMap.pdf && (
                            <tr>
                                <th>File&nbsp;size:</th>
                                <td>{activityMap.pdf_size_field ? formatBytes(activityMap.pdf_size_field, 2) : null}</td>
                            </tr>
                        )}
                        <tr>
                            <th>Dimensions:</th>
                            <td>36" X 72"</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        const { activityMap, authenticated, user } = this.props

        return (
            <Container id="activity-map--desktop" className="content-layout--two-column">
                <div>
                    { activityMap.cover_image && (
                        <div className="activity-map__image">
                            <img alt={activityMap.title} src={formatFileLink(activityMap.cover_image)} />
                        </div>
                    )}
                    { authenticated ? 
                        (<Fragment>
                            {this.renderDownloadButton(activityMap, authenticated, user)}                            
                            {this.renderContents(activityMap)}
                            <hr />
                            <EmailOptin
                                message="Sign up to receive weekly email alerts from Canadian Discovery when there are new Discovery Digest articles, features or events"
                                successMessage="Sign-up Successful"
                                role="Mail-9-Articles" />
                        </Fragment>) :
                        (<Fragment>
                            {this.renderContents(activityMap)}
                            {this.renderDownloadButton(activityMap, authenticated, user)}
                            <hr />
                            <CheckSubscription
                                message="A subscription to the Discovery Digest is required to view this content. Enter your email below to find out if your company subscribes."
                                productName="Canadian Discovery's Discovery Digest"
                                shortProductName="the Discovery Digest"
                                role="CDD" />
                        </Fragment>)
                    }
                </div>
                <div>
                    <H2>{activityMap.title} {<EditButton href={`${DJANGO_URL}/admin/content/activitymap/${activityMap.id}/change/`} />}</H2>
                    <Subtitle1>{activityMap.subtitle}</Subtitle1>
                    <Body1>{formatResultsItemDate(activityMap)}</Body1>
                    <Body1 dangerouslySetInnerHTML={{ __html: activityMap.description }} />
                    <hr />                    
                    <div className="flex flex--end">
                        <Share title={activityMap.title} url={window.location.origin + window.location.pathname} />
                    </div>
                </div>
            </Container>
        )
    }
}

ActivityMapDesktop.propTypes = {
    activityMap: PropTypes.object.isRequired,
    authenticated: PropTypes.bool.isRequired,
    handleLogin: PropTypes.func.isRequired,
    user: PropTypes.object,
    link: PropTypes.string,
    sampleLink: PropTypes.string
}

export default ActivityMapDesktop